import { z } from "zod";
import { CompositionConfigLight } from "../../../types";
import { ProfileV1Props } from "./types";

const ProfileV1Config: CompositionConfigLight<ProfileV1Props> = {
	name: "ProfileV1",
	assertValidProps: (props) => {
		return z
			.object({
				name: z.string(),
				profilePhotoUrl: z.string().optional(),
			})
			.parse(props) satisfies ProfileV1Props;
	},
	videoConfig: {
		numFrames: 1,
		width: 600,
		height: 960,
	},
};

export default ProfileV1Config;
